var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('Tree',{ref:"tree",attrs:{"data":_vm.data,"show-checkbox":_vm.showCheckbox,"multiple":_vm.multiple,"empty-text":_vm.emptyText},on:{"on-check-change":_vm.treeCheckChange}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }